export default {"src":"/_next/static/media/eye-hide.36ef3914.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};